export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12083.acb9e3fb.jpg";